import { Route } from "react-router";
import * as React from "react";
import DocumentViewerPage from "../screens/DocumentViewerPage";
import { DocumentsStoreProvider } from "../stores/context";

const withDocumentsProvider = (element: React.ReactNode) => (
    <DocumentsStoreProvider>{element}</DocumentsStoreProvider>
);

const documentRoute = () => {
    return (
        <>
            <Route
                path="/preview/:documentId/:documentName"
                element={withDocumentsProvider(<DocumentViewerPage />)}
            />
            <Route
                path="/document-viewer/:documentId"
                element={withDocumentsProvider(<DocumentViewerPage />)}
            />
        </>
    );
};

export default documentRoute;
